/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Playground',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path d="M6 7.401a2.1 2.1 0 0 1 2.1 2.1A2.1 2.1 0 1 1 3.9 9.5 2.1 2.1 0 0 1 6 7.4zM6 8.6a.901.901 0 1 0 0 1.801A.901.901 0 1 0 6 8.6zm-.248-4.146a.6.6 0 0 1 .572.042l3.5 2.25a.6.6 0 0 1 .275.505v6.501l2.059 2.059.744-9.118.02-.113a.6.6 0 0 1 .578-.437h7a.6.6 0 0 1 .598.551l1 12.26a.6.6 0 0 1-.549.646.6.6 0 0 1-.646-.549l-.955-11.709h-.831v7.125c.344.172.415.681.158.962-.03.033-.07.072-.119.112-.099.082-.235.173-.42.257-.369.168-.92.304-1.735.304s-1.366-.136-1.735-.304c-.185-.084-.321-.175-.42-.257a1.23 1.23 0 0 1-.119-.112c-.236-.258-.217-.709.081-.918a.56.56 0 0 1 .078-.045V7.341h-.832l-.782 9.582.482.483a3.4 3.4 0 0 0 2.404.996H17a.6.6 0 1 1 0 1.2h-.843a4.6 4.6 0 0 1-3.014-1.125l-.046.574a.6.6 0 0 1-.646.549.6.6 0 0 1-.549-.646l.128-1.572-1.931-1.932v3.553a.6.6 0 0 1-1.2 0v-.4H3.1v.4a.6.6 0 1 1-1.2 0V7.251a.6.6 0 0 1 .275-.505l3.5-2.25.076-.042zM3.1 17.401h5.8V16.6H3.1v.801zm0-2h5.8V14.6H3.1v.801zm12.984-.596c.212.05.509.095.916.095s.704-.045.916-.095V7.341h-1.832v7.465zM3.1 7.578v5.823h5.8V7.578L6 5.714 3.1 7.578z" />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
